import React, { useCallback } from "react";
import { Box, Link } from "@chakra-ui/react";
import runtimeEnv from "@mars/heroku-js-runtime-env";

const env = runtimeEnv();

interface IProps {
  closePrompt: () => void;
}

export const ConnectZapierForm: React.FC<IProps> = ({ closePrompt }) => {
  const handleClick = useCallback(() => closePrompt(), [closePrompt]);

  return (
    <Box py={5} color={"gray.400"}>
      <Box>
        <span>{`To learn how to integrate with Zapier, please `}</span>
        <Link
          href={`${env.REACT_APP_GUIDES_URL}/zapier-integration`}
          isExternal
          color={"blue.500"}
          onClick={handleClick}
        >
          read this guide.
        </Link>
      </Box>
    </Box>
  );
};
